var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleOnDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H16.2857C19.5994 0 22.2857 2.68629 22.2857 6V6C22.2857 9.31371 19.5994 12 16.2857 12H6C2.68629 12 0 9.31371 0 6V6Z",
    fill: "#DDDFDD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2855,
    cy: 5.99998,
    r: 3.42857,
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOnDisabled);
export default __webpack_public_path__ + "static/media/Toggle_on_disabled.44f880a10db301d6019c3303d8584a64.svg";
export { ForwardRef as ReactComponent };